var product_gallery_default = (() => {
    if (customElements.get("product-gallery")) return;
    customElements.define("product-gallery", class ProductGallery extends HTMLElement {
        connectedCallback() {
            this.track = this.querySelector("[data-product-media-track]");
            this.cells = Array.from(this.querySelectorAll("[data-product-image]"));
            this.progressBar = this.querySelector("[data-gallery-progress-track]");
            this.progressFill = this.querySelector("[data-gallery-progress]");
            if (!this.track || !this.progressBar || !this.progressFill) return;
            if (this.cells.length <= 1) {
                this.progressBar?.setAttribute("hidden", "");
                return;
            }
            this.lastTranslate = -1;
            this.lastThumb = -1;
            this.rafId = null;
            this.onScroll = () => this.scheduleUpdate();
            this.track.addEventListener("scroll", this.onScroll, {
                passive: true
            });
            this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
            this.resizeObserver.observe(this.track);
            this.scheduleUpdate();
        }
        disconnectedCallback() {
            this.track?.removeEventListener("scroll", this.onScroll);
            this.resizeObserver?.disconnect();
            if (this.rafId !== null) cancelAnimationFrame(this.rafId);
            this.rafId = null;
        }
        scheduleUpdate() {
            if (this.rafId !== null) return;
            this.rafId = requestAnimationFrame(() => {
                this.rafId = null;
                this.updateProgress();
            });
        }
        updateProgress() {
            const {scrollWidth: scrollWidth, clientWidth: clientWidth, scrollLeft: scrollLeft} = this.track;
            const maxScroll = scrollWidth - clientWidth;
            const raw = maxScroll > 0 ? scrollLeft / maxScroll : 0;
            const clamped = Math.min(1, Math.max(0, raw));
            const minThumbPx = 24;
            const barWidth = this.progressBar.clientWidth;
            const thumbPx = Math.max(minThumbPx, Math.round(clientWidth / scrollWidth * barWidth));
            const translatePx = clamped * (barWidth - thumbPx);
            if (Math.abs(translatePx - this.lastTranslate) < .5 && thumbPx === this.lastThumb) return;
            this.lastTranslate = translatePx;
            this.lastThumb = thumbPx;
            this.progressFill.style.setProperty("--gallery-thumb", `${thumbPx}px`);
            this.progressFill.style.setProperty("--gallery-progress", `${translatePx.toFixed(1)}px`);
        }
    });
})();